'use strict';
'use strict';

function urlFactory(appSettings) {
  const urlsForRequest = {
    'CONFIGURATION':         '/app/configuration',
    'CONTRACTS':             '/contract/list',
    'CONTRACT_DETAILS':      '/contract/:contractId',
    'EMAIL':                 '/contract/email',
    'FILTERS':               '/app/filters',
    'HEAT_MAP':              '/contract/list/:context/heatpoints',
    'MARKERS':               '/app/map/markers',
    'PARAMETER_BY_NAME':     '/parameter/byName/:cdSystem/:nmParameter',
    'SUPERVISORS':           '/contract/supervisors/:contractId/:siteId',
    'GET_PARAMETERS':        '/parameter/getParameters/:cdSystem/:parameters',
    'CLIENT_CONFIG_LOCAL':   'components/config/client-config',
    'CLIENT_CONFIG_BD':      '/filters/configs',
    'EDITAL':                '/contract/edict/:contractId',
    'LICENCAAMBIENTAL':      '/contract/license/:contractId',
    'FINANCIAL_SUMMARY':     '/contract/:contractId/financial-summary',
    'LABELS':                '/labels',
    'FAVORITE_FILTERS':      '/filters/favorites',
    'COORDENADAS_UF':        '/coordinates/uf/:uf',
    'COORDENADAS_MUNICIPIO': '/coordinates/city/:city',
    'CONTRACTS_REPORT':      '/contract/report',
    'CONTRACT_REPORT':       '/report/contract/'
  };

  return {
    getUrl:               function(URL) {
      return appSettings.getBaseUrl() + '/' + appSettings.getSource() + urlsForRequest[URL];
    },
    getLocalJSON:         function(URL, tenantId) {
      let requestURL = urlsForRequest[URL];
      let urlTenant = tenantId ? ('-' + tenantId) : '';
      return `${requestURL}${urlTenant}.json`;
    },
    getDirectUrl:         function(URL) {
      return appSettings.getBaseUrl() + urlsForRequest[URL];
    },
    getGoogleRoadsApiUrl: function(path) {
      return 'https://roads.googleapis.com/v1/snapToRoads'
        + '?path=' + path.join('|')
        + '&interpolate=true'
        + '&key=' + this.getGoogleApiKey();
    },
    // ApiKey do google vinculado ao email softplan.obras
    getGoogleApiKey:      function() {
      return appSettings.getGoogleApiKey();
    }
  };
}

urlFactory.$inject = ['appSettings'];
export default urlFactory



// WEBPACK FOOTER //
// ./src/app/scripts/factories/urlFactory.js